import interceptor from 'rest/interceptor';
import { ProcessAPI } from 'lecom-api';
import CurrentUserHandler from '../../user/handlers/current_user_handler.js';

const requestHandler = (request, config, meta) => {
	const getTestMode = CurrentUserHandler.getTestMode();
	const isTestMode = getTestMode === '""' ? undefined : getTestMode;
	const isRouteApiBPM = window.contextPath ? request.path.indexOf(window.contextPath) === -1 ? true : false : false;

	if (isTestMode && isRouteApiBPM) {
		request.headers['test-mode'] = !!isTestMode;
		request.headers['test-user'] = isTestMode;
	}

	if (request.path.search("documents/import") !== -1 || request.path.search("documents/files") !== -1 || request.path.search("/sign") !== -1 || request.path.search('/lock') !== -1 )
		request.headers['ticket-sso'] = CurrentUserHandler.getLecomSSOTicket();	

	if(localStorage.getItem("ticket"))
		request.headers['ticket-sso'] = localStorage.getItem("ticket");

	if(localStorage.getItem("language"))
		request.headers['language'] = localStorage.getItem("language");		

	if(ProcessAPI && ProcessAPI.currentProcess() && ProcessAPI.currentProcess().uuid())		
		request.headers['form-uuid'] = ProcessAPI.currentProcess().uuid();

	if (process.env.REACT_APP_MOCK) {		
		if (request && request.path && typeof request.path === "string" && request.path.split("/").length > 1) {
			request.method = "GET";
			request.path = `http://localhost:3000/form-web/mocks/${request.path.split("/")[request.path.split("/").length - 1]}.json`;		
		}
	}	

	if (request.params && Object.keys(request.params).length) {
		request.path = `${request.path}{?${Object.keys(request.params).join()}}`;		
	}

	if (process.env.NODE_ENV === 'production') {    
		request.mixin = {
			withCredentials: true
		}
	}		

	if (ProcessAPI.currentProcess().uuid()) {
		delete request.headers['ticket-sso'];
	} else {
		delete request.headers['form-uuid'];
	}

	return request;
};

const AccessInterceptor = interceptor({
	request: requestHandler
});

export const setAjaxSetup = () => {
	$.ajaxSetup({
		beforeSend: function(xhr){						
			if(ProcessAPI.currentProcess().language())
				xhr.setRequestHeader('language', ProcessAPI.currentProcess().language());			

			if(ProcessAPI.currentProcess().uuid())
				xhr.setRequestHeader('form-uuid', ProcessAPI.currentProcess().uuid());			
			else if(ProcessAPI.currentProcess().ticket())
				xhr.setRequestHeader('ticket-sso', ProcessAPI.currentProcess().ticket());				
		}
	});
}

export default AccessInterceptor;
